/**
 *
 * CardBirthDay
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Avatar } from "antd"
import iconClose from "images/close-white.svg"
import { CSSTransition } from "react-transition-group"
import "./index.less"
import {
  KEY_DASHBOARD_BIRTHDAY_CHECK,
  LOCAL_DASHBOARD_BIRTHDAY_CHECK,
  setItem,
} from "../../utils/storage"

class CardBirthDay extends React.Component {
  state = { visible: true }

  close = () => {
    const seen = JSON.parse(LOCAL_DASHBOARD_BIRTHDAY_CHECK())
    seen.push(this.props.data.id)
    setItem(KEY_DASHBOARD_BIRTHDAY_CHECK, JSON.stringify(seen))
    this.setState({ visible: false })
  }

  render() {
    const { data } = this.props
    return (
      <CSSTransition
        in={this.state.visible}
        timeout={300}
        classNames="zoom"
        unmountOnExit>
        <div className="cardBirthdayComponent">
          <div className="cardBirthdayComponent-wave" />
          <div className="cardBirthdayComponent-wave" />
          <div className="cardBirthdayComponent-content">
            <Avatar src={data.avatar} size={65} />
            <div>
              <h2>¡Hoy es el cumpleaños de {data.name}!</h2>
              <p>No olvides desearle un feliz cumpleaños.</p>
            </div>
          </div>
          <div className="cardBirthdayComponent-confetti" />
          <img
            src={iconClose}
            onClick={() => this.close()}
            className="cardBirthdayComponent-close"
          />
        </div>
      </CSSTransition>
    )
  }
}
CardBirthDay.defaultProps = {
  data: {
    name: "",
    avatar: "",
  },
}

export default CardBirthDay
